import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type TimeField = Extract<MaintenanceChecklistField, { type: 'time' }>;

type Props = {
  field: TimeField;
  readOnly?: boolean;
};

export function ChecklistTimeField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      <Input type="time" disabled={readOnly} />
    </ChecklistFieldShell>
  );
}
